module.exports = __webpack_public_path__ + "img/TagAmMeer.8bf7341d.svg";